import { get } from "lodash";
import authentication from "@irati/auth";
export var SELECT_TEAM = "select_team";
export var SUPER_ADMIN = "super-admin";
export var ADMIN = "admin";
export var USER = "user";
export var MANAGER = "manager";
export var SUPER_ADMIN_OPTION = { label: "admin.roles.superAdmin", value: SUPER_ADMIN };
export var ADMIN_OPTION = { label: "admin.roles.admin", value: ADMIN };
export var USER_OPTION = { label: "admin.roles.user", value: USER };
export var MANAGER_OPTION = { label: "admin.roles.manager", value: MANAGER };
export var OPTIONS = [
    USER_OPTION,
    MANAGER_OPTION,
    ADMIN_OPTION
];
export var RESOLVED_OPTIONS = function (formatMessage) {
    var options = OPTIONS.map(function (option) {
        return { label: formatMessage({ id: get(option, "label", "") }), value: get(option, "value", "") };
    });
    if (authentication.hasSuperAdminRole() || authentication.isUserGhost() || authentication.isInternal()) {
        options.push({ label: formatMessage({ id: SUPER_ADMIN_OPTION.label }), value: SUPER_ADMIN_OPTION.value });
    }
    return options;
};
